import slugify from 'slugify'

export type MicroCatKind = 'eyewear' | 'makeup' | 'fragrance'

export type SingleSizeDisplay = {
  sizeInfoLabelKey?: string
  asColorAsLabel?: boolean
  hideColorBlock?: boolean
  sizeLabelKey?: string
}

const SINGLE_SIZE_MICROCATS: Record<MicroCatKind, string[]> = {
  eyewear: ['sunglasses', 'optical-frames'],
  makeup: [
    'blush-and-bronzer',
    'compact-foundation',
    'concealer',
    'eye-pencil',
    'eyebrows',
    'eyeliner',
    'eyeshadow',
    'face-primer',
    'full-coverage-foundation',
    'highlighter',
    'lip-balm',
    'lip-gloss',
    'lipstick',
    'liquid-foundation',
    'make-up-tools',
    'mascara',
  ],
  fragrance: ['fragrances'],
}

const normalizeMicroCat = (value: string): string =>
  slugify(value, { lower: true, trim: true, strict: false })

export const getMicroCatKind = (
  microCatEn?: string | null
): MicroCatKind | null => {
  if (!microCatEn) return null
  const slug = normalizeMicroCat(microCatEn)
  const match = Object.entries(SINGLE_SIZE_MICROCATS).find(([, slugs]) =>
    slugs.includes(slug)
  )
  return match ? (match[0] as MicroCatKind) : null
}

const SINGLE_SIZE_DISPLAY: Record<MicroCatKind, SingleSizeDisplay> = {
  eyewear: { sizeInfoLabelKey: 'pdp.sizeSelector.caliber' },
  makeup: {
    asColorAsLabel: true,
    hideColorBlock: true,
    sizeLabelKey: 'pdp.sizeSelector.variant',
  },
  fragrance: { asColorAsLabel: true, sizeLabelKey: 'pdp.sizeSelector.format' },
}

export const getSingleSizeDisplay = (
  kind?: MicroCatKind | null
): SingleSizeDisplay | undefined =>
  kind ? SINGLE_SIZE_DISPLAY[kind] : undefined

export const isSingleSizeMicroCat = (
  microCatKind: MicroCatKind | null,
  sizeCount: number,
  hasExtSizes: boolean
): boolean => microCatKind !== null && sizeCount === 1 && !hasExtSizes
